<div *ngIf="show" class="custom-alert">
    <div style="display: flex; align-items: center;">
        <img src="../../../../assets/images/alert-warning-icon.png" alt="Alert Icon" style="margin-right: 10px; height: 40px; width: 40px;">
        <div>
            <p class="alert-title trancate-one">{{alertRibbonData[0].title}}</p>
            <p class="message trancate-one" *ngIf="alertRibbonData[0].title != 'Live/Ongoing Auction'">{{alertRibbonData[0].message}}</p>
            <app-countdown *ngIf="alertRibbonData[0].title == 'Live/Ongoing Auction'" [auctionEnd]="alertRibbonData[0]?.auctionEnd"></app-countdown>
        </div>
    </div>
     <div style="display: flex; align-items: center;">
         <button type="button" class="btn btn-warning btn-block" *ngIf="alertRibbonData && alertRibbonData.length > 0 && alertRibbonData[0]?.cta" style="min-width: 100px;cursor: pointer;" (click)="handleParticipate()">{{alertRibbonData[0]?.cta}}</button>
         <span class="close-btn" (click)="close()"><img src="../../../../assets/images/alert-x-close.png" alt="X" style="margin-right: 10px; height: 20px; width: 20px;"></span>
        </div>
</div>

